// extracted by mini-css-extract-plugin
export var closeButton = "_li-2";
export var closeButtonIcon = "_li-3";
export var lightboxContent = "_li-1";
export var lightboxOverlay = "_li-0";